import { Control, Controller, UseControllerProps } from 'react-hook-form';
import { TextAreaInput, TextAreaInputProps } from '@aqarmap/aqarmap-ui';
import useInputRules from '~/components/DesignSystem/Inputs/useInputRules';
import { RuleName } from '~/components/DesignSystem/Inputs/types';

type Props = TextAreaInputProps & {
  control: Control<any>;
  ruleName: RuleName;
  validationRules?: UseControllerProps['rules'];
};

const TextAreaInputController: React.FC<Props> = ({
  field: { name, required, children: ignoredChildren, ...restField },
  control,
  ruleName,
  validationRules,
  error,
  ...rest
}) => {
  void ignoredChildren;
  const inputRules = useInputRules({ required, ruleName });
  return (
    <Controller
      control={control}
      name={name ?? ''}
      rules={{
        ...inputRules,
        ...validationRules,
      }}
      render={({ fieldState: { error: fieldStateError }, field }) => {
        return (
          <TextAreaInput
            {...rest}
            error={fieldStateError?.message ?? error}
            field={{
              ...restField,
              ...field,
              value: field.value || '',
              name,
            }}
          />
        );
      }}
    />
  );
};

export default TextAreaInputController;
